<div
  *ngIf="open"
  class="fpm-backdrop"
  (click)="onBackdropClick()"
  role="dialog"
  aria-modal="true"
  aria-labelledby="firm-picker-title"
>
  <div class="fpm-card" (click)="$event.stopPropagation()">
    <h2 id="firm-picker-title" class="fpm-title">Switch Firm</h2>

    <div class="fpm-body">
      <div class="fpm-field" *ngIf="isSuperAdmin">
        <label class="fpm-label" for="fpm-group-select">Group</label>
        <select
          id="fpm-group-select"
          class="fpm-select"
          data-testid="firm-picker-group-select"
          [value]="selectedGroupId ?? ''"
          (change)="onGroupSelectChange($event)"
          [disabled]="isConfirming"
          aria-label="Select group"
        >
          <option value="" disabled *ngIf="selectedGroupId === null">Select Group...</option>
          <option
            *ngFor="let group of accessibleGroups"
            [value]="group.GROUP_ID"
            [selected]="group.GROUP_ID === selectedGroupId"
          >
            {{ group.GROUP_NAME }}
          </option>
        </select>
      </div>

      <div class="fpm-field">
        <label class="fpm-label" for="fpm-org-select">Firm</label>
        <select
          id="fpm-org-select"
          class="fpm-select"
          data-testid="firm-picker-org-select"
          [value]="selectedOrgId ?? ''"
          (change)="onOrgSelectChange($event)"
          [disabled]="isConfirming || (isSuperAdmin && selectedGroupId === null)"
          aria-label="Select firm"
        >
          <option value="" disabled *ngIf="selectedOrgId === null">Select Firm...</option>
          <option
            *ngFor="let org of accessibleOrgs"
            [value]="org.ORGANIZATION_ID"
            [selected]="org.ORGANIZATION_ID === selectedOrgId"
          >
            {{ org.ORGANIZATION_NAME }}
          </option>
        </select>
      </div>
    </div>

    <div class="fpm-footer">
      <button
        type="button"
        class="fpm-btn fpm-btn-cancel"
        (click)="onCancel()"
        [disabled]="isConfirming"
      >
        Cancel
      </button>
      <button
        type="button"
        class="fpm-btn fpm-btn-confirm"
        data-testid="firm-picker-confirm"
        (click)="onConfirm()"
        [disabled]="!canConfirm"
      >
        {{ isConfirming ? 'Switching...' : 'Confirm' }}
      </button>
    </div>
  </div>
</div>
